import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-checkout__summary mb-4 data-box"
};
const _hoisted_2 = { class: "item" };
const _hoisted_3 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_dynamic_html = _resolveComponent("g-dynamic-html");
    const _component_g_link = _resolveComponent("g-link");
    return (_ctx.schema?.summary)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schema.summary, (summary) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", null, _toDisplayString(summary.caption), 1),
                    _createElementVNode("div", null, [
                        _createVNode(_component_g_dynamic_html, {
                            template: summary.description
                        }, null, 8, ["template"])
                    ]),
                    (summary.actionUrl && !_ctx.cart.isReadOnly)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createVNode(_component_g_link, {
                                src: summary.actionUrl
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(summary.actionCaption), 1)
                                ]),
                                _: 2
                            }, 1032, ["src"])
                        ]))
                        : _createCommentVNode("", true)
                ]));
            }), 256))
        ]))
        : _createCommentVNode("", true);
}
